import { motion } from "framer-motion";
import { MessageCircle, Phone } from "lucide-react";
import { BRAND, waLink } from "@/config/brand";

export const StickyCta = () => (
  <motion.div
    initial={{ y: 80 }}
    animate={{ y: 0 }}
    transition={{ delay: 1.2, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
    data-testid="sticky-cta-bar"
    className="fixed inset-x-0 bottom-0 z-50 flex gap-3 border-t border-line bg-white/95 p-3 backdrop-blur-xl md:hidden"
  >
    <a
      href={`tel:${BRAND.phone}`}
      data-testid="sticky-call-btn"
      className="flex flex-1 items-center justify-center gap-2 rounded-xl bg-brand py-3 text-sm font-bold text-white active:scale-[0.98]"
    >
      <Phone className="h-4 w-4" /> Call advisor
    </a>
    <a
      href={waLink()}
      target="_blank"
      rel="noreferrer"
      data-testid="sticky-whatsapp-btn"
      className="flex flex-1 items-center justify-center gap-2 rounded-xl border border-line bg-white py-3 text-sm font-bold text-ink active:scale-[0.98]"
    >
      <MessageCircle className="h-4 w-4 text-brand" /> WhatsApp
    </a>
  </motion.div>
);
